import { render } from "./search-view-component.vue?vue&type=template&id=8fe9762a&scoped=true&ts=true"
import script from "./search-view-component.vue?vue&type=script&lang=ts"
export * from "./search-view-component.vue?vue&type=script&lang=ts"

import "./search-view-component.vue?vue&type=style&index=0&id=8fe9762a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fe9762a"]])

export default __exports__